import React from 'react';

import TooltipStep from '../TooltipStep';

interface NewslettersProps {
  handleClose: () => void;
  handleNext: () => void;
  isProSubscriber: boolean;
  step: number;
  totalSteps?: number;
}

const Newsletters = (props: NewslettersProps) => (
  <TooltipStep
    {...props}
    title="Newsletters"
    description="From the newsroom to your inbox, follow the stories you care about."
  />
);

export default Newsletters;
